type ParallaxOptions = {
  selector: string;
  container?: HTMLElement;      // new container reference
  speeds?: number[];            // optional per-item speeds
  maxTranslate?: number;        // optional clamp
};

export function initParallax({
  selector,
  container,
  speeds,
  maxTranslate = 200,
}: ParallaxOptions) {
  if (!container) {
    console.warn("Parallax container not provided");
    return;
  }

  const items = Array.from(container.querySelectorAll<HTMLElement>(selector));
  if (!items.length) return;

  const rates =
    speeds && speeds.length === items.length
      ? speeds
      : items.map((_, i) => 0.1 + i * 0.05);

  items.forEach((it) => {
    it.style.willChange = "transform";
    it.style.transform = "translate3d(0,0,0)";
  });

  let ticking = false;

  const isInViewport = () => {
    const rect = container.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  };

  const update = () => {
    if (!isInViewport()) {
      ticking = false;
      return; // skip if container is not visible
    }

    const scrollTop = window.scrollY;

    items.forEach((item, i) => {
      const offset = scrollTop * rates[i];
      const clampedOffset =
        offset > maxTranslate
          ? maxTranslate
          : offset < -maxTranslate
          ? -maxTranslate
          : offset;

      item.style.transform = `translate3d(0, ${clampedOffset}px, 0)`;
    });

    ticking = false;
  };

  const onScroll = () => {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  };

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll);

  update(); // initial call

  return {
    destroy() {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      items.forEach((it) => (it.style.transform = ""));
    },
  };
}
